import { render } from "./project-type.vue?vue&type=template&id=85ea2eb0&scoped=true"
import script from "./project-type.vue?vue&type=script&lang=js"
export * from "./project-type.vue?vue&type=script&lang=js"

import "./project-type.vue?vue&type=style&index=0&id=85ea2eb0&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ea2eb0"]])

export default __exports__